import {Injectable} from '@angular/core';
import {ActiveMenuModel, MenuModel} from '../../../models/menu.model';
import {currentMenuUrls, MenuItemsMap, menuPermissionsMap} from '../models/menu-const-models';
import {MemberModel} from '../../../models/user.model';
import {environment} from '../../../../environments/environment';
import {Observable, of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LayoutMenuService {
  prepareMenu(resMenu: MenuModel[], profileData:MemberModel): Observable<ActiveMenuModel[]> {
    let appMenu: ActiveMenuModel[] = resMenu.map(globalMenuItem => {
      let childrens = globalMenuItem.children.map(child => {
        let activeChild: ActiveMenuModel = {
          title: child.title_sub,
          isHide:  menuPermissionsMap.get(child.sub_acc_type)?.includes(profileData.project_setting.observation_type) === false,
          key: child.submenu_key,
          url: currentMenuUrls[child.submenu_key],
        };
        return activeChild;
      });
      let menuItem: ActiveMenuModel = {
        title: globalMenuItem.title,
        icon: MenuItemsMap.get(globalMenuItem.menu_key)?.icon||'arrow-down-s-line',
        isHide: menuPermissionsMap.get(globalMenuItem.acc_type||'BLOCKED')?.includes(profileData.project_setting.observation_type) === false,
        children: childrens,
        menu_key: globalMenuItem.menu_key,
      };
      return menuItem;
    });
      /* Настройки */
    if (profileData.project_setting.is_project_admin) {
      appMenu.push({
        title: '',
        isHide: false,
        icon: MenuItemsMap.get('MENU_SETTINGS')?.icon,
        menu_key: 'MENU_SETTINGS',
        children: [
          {
            title: '',
            url: ['account', 'options', 'properties'],
            icon: 'bi bi-card-list',
            key: 'CUSTOM_PROPERTY'
          },
          {
            title: '',
            url: ['account', 'options', 'catalogs'],
            icon: 'bi bi-justify',
            key: 'CATALOGS'
          },
          {
            title: '',
            url: ['account', 'options', 'menu'],
            icon: 'bi bi-menu-button-wide',
            key: 'MENU'
          },
          {
            title: '',
            url: ['account', 'options', 'general'],
            icon: 'bi bi-buildings',
            key: 'PROJECT'
          },
        ],
      });
    }
    if (environment.production === false) {
      appMenu.push({
        title: '',
        isHide: false,
        icon: MenuItemsMap.get('MENU_TEMPLATE')?.icon,
        menu_key: 'MENU_TEMPLATE',
        children: [{
            title: '',
            url: ['account', 'template', 'all'],
            icon: 'bi bi-card-list',
            key: 'TEMPLATE_ALL'
        }]
      });
    }
    return of(appMenu)
  }
}